import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AuditsComponent } from './audits.component';
import { ButtonModule } from '../shared/components/button/button.module';
import { RouterModule } from '@angular/router';
import { DialogModule } from '../shared/components/dialog/dialog.module';
import { DropdownModule } from '../shared/components/dropdown/dropdown.module';
import { DatepickerInputModule } from '../shared/components/datepicker-input/datepicker-input.module';
import { AuditDetailsComponent } from './audit-details/audit-details.component';
import { FormattedDateModule } from '../shared/pipes/formatted-date/formatted-date.module';
import { BadgeModule } from '../shared/components/badge/badge.module';
import { InputSearchScannerModule } from '../shared/components/input-search-scanner/input-search-scanner.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputModule } from '../shared/components/input/input.module';
import { EnterPinDialogModule } from '../shared/components/enter-pin-dialog/enter-pin-dialog.module';
import { ResetPinDialogModule } from '../shared/components/reset-pin-dialog/reset-pin-dialog.module';
import { MenuModule } from '../shared/components/menu/menu.module';
import { AuditDetailsAdjustmentsTransactionComponent } from './audit-details/audit-details-adjustments-transaction/audit-details-adjustments-transaction.component';
import { ReceiveDialogModule } from '../dashboard/components/user-board/dialogs/receive-dialog/receive-dialog.module';
import { TooltipModule } from '../shared/components/tooltip/tooltip.module';
import { SelectedNdcInputModule } from '../shared/components/selected-ndc-input/selected-ndc-input.module';
import { TextareaModule } from '../shared/components/textarea/textarea.module';
import { AuditDetailsNoteModalComponent } from './audit-details/audit-details-note-modal/audit-details-note-modal.component';
import { PendingTransactionCardsModule } from '../dashboard/components/transactions-table/pending-transactions-carousel/pending-transaction-card/pending-transaction-cards.module';
import { PendingTransactionDialogModule } from '../dashboard/components/user-board/dialogs/pending-transaction-dialog/pending-transaction-dialog/pending-transaction-dialog.module';
import { EmptyTableModule } from '../shared/components/empty-table/empty-table.module';
import { DiscrepancyInfoWithTooltipModule } from './audit-details/discrepancy-info-with-tooltip/discrepancy-info-with-tooltip.module';
import { ErrorMessageModule } from '../shared/error-message/error-message.module';
import { AlertModule } from '../shared/components/alert/alert.module';
import { LoadingModule } from '../shared/components/loading/loading.module';
import { OptionsListModule } from '../shared/components/options-list/options-list.module';
import { MultipleDrugsDialogBaseModule } from '../dashboard/components/user-board/dialogs/multiple-drugs-dialog-base/multiple-drugs-dialog-base.module';
import { NavigatedFromModule } from '../shared/pipes/navigated-from/navigated-from.module';
import { NavigatedFromPipe } from '../shared/pipes/navigated-from/navigated-from.pipe';
import { SchedulesFilterModule } from '../shared/components/schedules-filter/schedules-filter.module';
import { InventoryLocationsFilterModule } from '../shared/components/inventory-locations-filter/inventory-locations-filter.module';
import { MoveInventoryDialogModule } from '../dashboard/components/user-board/dialogs/move-inventory-dialog/move-inventory-dialog.module';
import { LocationsListPipe } from '../shared/pipes/locations-list/locations-list.pipe';
import { SchedulesListPipe } from '../shared/pipes/schedules-list/schedules-list.pipe';
import { SearchInputModule } from '../shared/components/search-input/search-input.module';
import { MultiselectDropdownModule } from '../shared/components/multiselect-dropdown/multiselect-dropdown.module';

const routes = [
  {
    path: '', component: AuditsComponent,
    children: [],
  },
  {
    path: 'details/:id', component: AuditDetailsComponent,
  },
];

@NgModule({
  declarations: [
    AuditsComponent, 
    AuditDetailsComponent, 
    AuditDetailsAdjustmentsTransactionComponent, 
    AuditDetailsNoteModalComponent,
    LocationsListPipe,
    SchedulesListPipe
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ButtonModule,
    DialogModule,
    DropdownModule,
    DatepickerInputModule,
    FormattedDateModule,
    BadgeModule,
    ReactiveFormsModule,
    FormsModule,
    InputModule,
    InputSearchScannerModule,
    EnterPinDialogModule,
    ResetPinDialogModule,
    MenuModule,
    ReceiveDialogModule,
    TooltipModule,
    SelectedNdcInputModule,
    TextareaModule,
    PendingTransactionCardsModule,
    PendingTransactionDialogModule,
    EmptyTableModule,
    DiscrepancyInfoWithTooltipModule,
    ErrorMessageModule,
    AlertModule,
    LoadingModule,
    OptionsListModule,
    MultipleDrugsDialogBaseModule,
    NavigatedFromModule,
    SchedulesFilterModule,
    InventoryLocationsFilterModule,
    MoveInventoryDialogModule,
    SearchInputModule,
    MultiselectDropdownModule
  ],
  exports: [AuditsComponent],
  providers: [
    DatePipe,
    NavigatedFromPipe
  ],
})
export class AuditsModule { }
